var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('yimo-vue-editor',{ref:"yimoEditor",attrs:{"config":_vm.editorConfig},on:{"onchange":_vm.onDropPanel},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }